export const WEEK_STATES = [
  "draft",
  "signup_open",
  "planning",
  "completed",
] as const

export type WeekState = (typeof WEEK_STATES)[number]
